export default [
    {
        path: '/organizations/new',
        name: 'tenant.register',
        component: () => import(/* webpackChunkName: "tenants" */ '@/pages/organizations/new.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },

    {
        path: '/organizations/playground/new',
        name: 'tenant.playground.create',
        component: () => import(/* webpackChunkName: "tenants" */ '@/pages/organizations/playground-new.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },

    {
        path: '/organizations/playground/start-over',
        name: 'tenant.playground.start-over',
        component: () => import(/* webpackChunkName: "tenants" */ '@/pages/organizations/playground-start-over.vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },

    {
        path: '/organizations/accept-invitation/:token',
        name: 'tenant.accept-invitation',
        component: () => import(/* webpackChunkName: "tenants" */ '@/pages/organizations/accept-invitation/[token].vue'),
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
    },
];
